import { AlertCircle, MapPin, RefreshCw } from 'lucide-react';
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@flexibilitypay/ui';

import { useProvinciasQuery } from '../../hooks/use-provincias-query';

export function ProvinciasPage() {
  const { data, isLoading, isFetching, isError, error, refetch } = useProvinciasQuery();

  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h2 className="text-2xl font-semibold tracking-tight">Provincias</h2>
          <p className="text-sm text-muted-foreground">
            Catálogo de provincias argentinas habilitadas para onboarding — origen:
            wrapper-carta-sur
          </p>
        </div>
        <Button
          variant="outline"
          onClick={() => refetch()}
          disabled={isFetching}
        >
          <RefreshCw className={isFetching ? 'animate-spin' : undefined} />
          Refrescar
        </Button>
      </div>

      <Card>
        <CardHeader>
          <div className="flex items-center gap-3">
            <div className="flex size-9 items-center justify-center rounded-lg bg-indigo-500/10 text-indigo-600">
              <MapPin className="size-5" />
            </div>
            <div>
              <CardTitle className="text-base">Listado</CardTitle>
              <CardDescription>
                {isLoading
                  ? 'Cargando…'
                  : isError
                    ? 'Error al consultar el wrapper'
                    : `${data?.length ?? 0} provincias`}
              </CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent className="px-0">
          {isError && (
            <div className="mx-6 mb-4 flex items-start gap-3 rounded-md border border-destructive/30 bg-destructive/5 p-3 text-sm text-destructive">
              <AlertCircle className="size-4 mt-0.5 shrink-0" />
              <div className="flex-1">
                <p className="font-medium">No se pudieron cargar las provincias</p>
                <p className="text-xs opacity-80">
                  {error?.message ?? 'Error desconocido'}
                </p>
              </div>
            </div>
          )}

          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="pl-6">Código ISO</TableHead>
                <TableHead>Provincia</TableHead>
                <TableHead>País</TableHead>
                <TableHead className="pr-6">ID</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {isLoading &&
                Array.from({ length: 6 }).map((_, i) => (
                  <TableRow key={i}>
                    <TableCell className="pl-6">
                      <div className="h-4 w-14 rounded bg-muted animate-pulse" />
                    </TableCell>
                    <TableCell>
                      <div className="h-4 w-40 rounded bg-muted animate-pulse" />
                    </TableCell>
                    <TableCell>
                      <div className="h-4 w-24 rounded bg-muted animate-pulse" />
                    </TableCell>
                    <TableCell className="pr-6">
                      <div className="h-4 w-64 rounded bg-muted animate-pulse" />
                    </TableCell>
                  </TableRow>
                ))}

              {!isLoading && !isError && data?.length === 0 && (
                <TableRow>
                  <TableCell
                    colSpan={4}
                    className="h-24 text-center text-sm text-muted-foreground"
                  >
                    Sin provincias para mostrar
                  </TableCell>
                </TableRow>
              )}

              {!isLoading &&
                data?.map((p) => (
                  <TableRow key={p.idProvincia}>
                    <TableCell className="pl-6 font-mono text-xs">
                      {p.codigoIsoProvincia}
                    </TableCell>
                    <TableCell className="font-medium">{p.nombreProvincia}</TableCell>
                    <TableCell className="text-muted-foreground">
                      {p.nombrePais}
                    </TableCell>
                    <TableCell className="pr-6 font-mono text-[11px] text-muted-foreground">
                      {p.idProvincia}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
